<template>
  <a-layout id="layout">
    <a-layout-sider v-model:collapsed="collapsed" :trigger="null" collapsible>
      <div class="logo">仓颉</div>
      <a-menu theme="dark" mode="inline" @click="changeMenu">
        <a-menu-item key="customer/list">
          <user-outlined />
          <span>客户管理</span>
        </a-menu-item>
        <a-menu-item key="project/list">
         <hdd-outlined />
          <span>项目管理</span>
        </a-menu-item>
        <a-sub-menu>
          <template #title>
            <span>
              <setting-outlined />
              <span>系统设置</span>
            </span>
          </template>
          <a-menu-item @click="logOut()">退出登录</a-menu-item>
        </a-sub-menu>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header style="background: #fff; padding: 0">
        <a-row type="flex" justify="space-between">
          <a-col>
            <menu-unfold-outlined
              v-if="collapsed"
              class="trigger"
              @click="() => (collapsed = !collapsed)"
            />
            <menu-fold-outlined
              v-else
              class="trigger"
              @click="() => (collapsed = !collapsed)"
            />
            <a-button style="margin-right: 16px" @click="backURL()"
              >返回</a-button
            >
          </a-col>
          <a-col style="margin-right: 60px; display: flex; align-items: center;">
            <a-dropdown v-if="isSuper">
              <a class="user-switch-trigger" @click.prevent>
                <span v-if="actingFor" style="color: #1890ff;">
                  {{ currentUsername }} (代理中)
                </span>
                <span v-else>{{ currentUsername }}</span>
                <swap-outlined style="margin-left: 8px;" />
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item v-if="actingFor" @click="switchBack">
                    <rollback-outlined /> 切回 {{ actingFor }}
                  </a-menu-item>
                  <a-menu-divider v-if="actingFor" />
                  <a-menu-item @click="showUserModal = true">
                    <team-outlined /> 切换用户
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
            <span v-else>{{ currentUsername }}</span>
          </a-col>
        </a-row>
      </a-layout-header>
      <a-layout-content
        :style="{
          margin: '24px 16px',
          padding: '24px',
          background: '#fff',
          minHeight: '280px',
          overflow: 'auto',
        }"
      >
        <router-view></router-view>
      </a-layout-content>
    </a-layout>
  </a-layout>

  <a-modal
    v-model:visible="showUserModal"
    title="切换用户"
    :footer="null"
    @cancel="showUserModal = false"
  >
    <a-spin :spinning="loadingUsers">
      <a-input-search
        v-model:value="userSearchKeyword"
        placeholder="搜索用户"
        style="margin-bottom: 16px;"
      />
      <a-list
        :data-source="filteredUsers"
        :bordered="true"
        size="small"
        style="max-height: 400px; overflow-y: auto;"
      >
        <template #renderItem="{ item }">
          <a-list-item>
            <template #actions>
              <a-button 
                type="link" 
                size="small"
                @click="switchToUser(item.username)"
                :disabled="item.username === currentUsername"
              >
                切换
              </a-button>
            </template>
            <a-list-item-meta>
              <template #title>
                {{ item.username }}
                <a-tag v-if="item.is_super" color="gold">超级管理员</a-tag>
              </template>
            </a-list-item-meta>
          </a-list-item>
        </template>
      </a-list>
    </a-spin>
  </a-modal>
</template>
<script>
import {
  UserOutlined,
  SettingOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  HddOutlined,
  SwapOutlined,
  TeamOutlined,
  RollbackOutlined,
} from "@ant-design/icons-vue";

export default {
  components: {
    UserOutlined,
    SettingOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    HddOutlined,
    SwapOutlined,
    TeamOutlined,
    RollbackOutlined,
  },
  data() {
    return {
      selectedKeys: ["1"],
      collapsed: true,
      showUserModal: false,
      loadingUsers: false,
      users: [],
      userSearchKeyword: "",
    };
  },
  computed: {
    currentUsername() {
      return this.$user?.get('username') || '';
    },
    isSuper() {
      const userData = JSON.parse(localStorage.getItem('cangjie_user') || '{}');
      return userData.is_super || userData.acting_for;
    },
    actingFor() {
      const userData = JSON.parse(localStorage.getItem('cangjie_user') || '{}');
      return userData.acting_for || null;
    },
    filteredUsers() {
      if (!this.userSearchKeyword) return this.users;
      const keyword = this.userSearchKeyword.toLowerCase();
      return this.users.filter(u => 
        u.username.toLowerCase().includes(keyword)
      );
    },
  },
  watch: {
    showUserModal(val) {
      if (val) {
        this.loadUsers();
      }
    },
  },
  mounted() {
    // 如果 $user 为空但有 token，重新初始化
    if (!this.$user) {
      const user = this.$lc.User.current();
      if (user) {
        this.$user = user;
      }
    }
  },
  methods: {
    changeMenu(item) {
      this.$router.push("/" + item.key);
    },
    async logOut() {
      await this.$lc.User.logOut();
      this.$user = null;
      this.$router.push("/login");
    },
    backURL() {
      this.$router.back();
    },
    async loadUsers() {
      this.loadingUsers = true;
      try {
        this.users = await this.$lc.User.fetchUsers();
      } catch (error) {
        this.$message.error('加载用户列表失败');
      } finally {
        this.loadingUsers = false;
      }
    },
    async switchToUser(username) {
      try {
        const user = await this.$lc.User.switchUser(username);
        this.$user = user;
        this.showUserModal = false;
        this.$message.success(`已切换到用户: ${username}`);
        this.$router.go(0);
      } catch (error) {
        this.$message.error(error.message || '切换用户失败');
      }
    },
    async switchBack() {
      try {
        const user = await this.$lc.User.switchBack();
        this.$user = user;
        this.$message.success('已切回超级管理员');
        this.$router.go(0);
      } catch (error) {
        this.$message.error(error.message || '切换失败');
      }
    },
  },
};
</script>
<style scoped>
#layout {
  height: 100vh;
}

#layout .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#layout .trigger:hover {
  color: #1890ff;
}

#layout .logo {
  height: 32px;
  line-height: 32px;
  color: #fff;
  font-size: 18px;
  text-align: center;
  margin: 16px;
}

.user-switch-trigger {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.user-switch-trigger:hover {
  color: #1890ff;
}
</style>
